import React, { Component } from 'react'
import DataTable from "./container/DataTable"
import DataHeader from "./container/DataHeader"

export default class index extends Component {
  render() {
    return (
      <div>
        <div className="clearfix wrapper-box-first">
          <DataHeader store={this.props.store} />
        </div>
        <div>
          <DataTable store={this.props.store} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgs/data_statistics/timingTask/index.js